import { PageHeader } from "@/components/site/PageHeader";
import { BreedingSection } from "@/components/sections/BreedingSection";
import { IMAGES } from "@/lib/content";

export default function Breeding() {
  return (
    <>
      <PageHeader label="The Breeding Room" title="THE BREEDING PROJECTS" image={IMAGES.blueRam}>
        Structured breeding attempts, documented honestly. Species and setups may change as the project
        develops — nothing here is a finished project yet.
      </PageHeader>
      <BreedingSection />
    </>
  );
}
